import { getFormattedDateString } from 'lib/DateTime';
import { NEWS_NOW_PID } from 'lib/playmaker';

const DATE_OPTIONS = { format: 'd M D', useAP: false, commaAfterDay: false };

export const METADATA_DEFAULTS = {
  playmakerId: NEWS_NOW_PID,
  playmakerTitle: `NBC News NOW for ${getFormattedDateString(Date.now(), null, DATE_OPTIONS)}`,
  playmakerDescription: 'NBC News NOW is a streaming network from NBC News. NOW features deep reporting, thoughtful storytelling, and live, breaking news from the global resources of NBC News.',
  playmakerArt: 'news-now-opening',
  playmakerPlayBehavior: 'clickToPlay',
  playmakerAutoplayMuted: true,
};

const mergeOverride = (defaultValue, override) => (
  defaultValue === 'other'
    ? override
    : defaultValue
);

export default function getMetadata(metadata) {
  const {
    playmakerToggle,
    playmakerId,
    playmakerIdOverride,
    playmakerArt,
    playmakerArtOverride,
    ...rest
  } = {
    ...METADATA_DEFAULTS,
    ...metadata,
  };

  // Playmaker is turned OFF
  if (playmakerToggle !== true) return { playmakerToggle };

  // Playmaker is turned ON
  return {
    ...rest,

    playmakerToggle,

    // There are two inputs for Playmaker ID (a select and a textbox for injecting new pids)
    playmakerId: mergeOverride(playmakerId, playmakerIdOverride),

    // There are two inputs for Playmaker Art (a select and a textbox for injecting new guids)
    playmakerArt: mergeOverride(playmakerArt, playmakerArtOverride),
  };
}
